<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h3>Newsletter Footers</h3>
  <div class="row mb-4">
    <div class="col-md-4">
      <a type="button" class="btn btn-primary m-2" routerLink="/newsletter_footers/new">New Footer</a>&nbsp;
      <span class="m-2">No. of footer: {{ maxCount }}</span>
    </div>
    <div class="col-md-4 offset-md-4">
      <a type="button" class="btn btn-primary m-2" href="#" (click)="goToRailsPage($event, '/newsletters')">Newsletters</a>&nbsp;
      <a type="button" class="btn btn-primary m-2" href="#" (click)="goToRailsPage($event, '/newsletter_mailinglists')">Mailing Lists</a>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-4">
      <span>
        <pagination
          (pageChanged)="index($event)"
          class="pagination-sm"
          [boundaryLinks]="true"
          [totalItems]="maxCount"
          [maxSize]="paginateParams.per_page"
          [itemsPerPage]="paginateParams.per_page"
          [(ngModel)]="paginateParams.page"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </span>
    </div>
    <div class="col-md-4 offset-md-4">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"> Footer Name </span>
        </div>
        <input type="text" class="form-control" [(ngModel)]="searchTerm" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" (click)="searchNewsletterFooters()">Search</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col">
      <table class="table">
        <thead>
          <tr>
            <th>S. No.</th>
            <th>Name</th>
            <th>Preview</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let newsletterFooter of newsletterFooters">
            <td>{{ newsletterFooters.indexOf(newsletterFooter) + 1 }}</td>
            <td>{{ newsletterFooter.name }}</td>
            <td>
              <a type="button" routerLink="/newsletter_footers/{{ newsletterFooter.id }}"><i class="fas fa-folder-open"></i></a>
            </td>
            <td>
              <a type="button" routerLink="/newsletter_footers/{{ newsletterFooter.id }}/edit"><i class="fas fa-pencil-alt"></i></a>
            </td>
            <td>
              <button type="button" class="btn btn-danger" [disabled]="newsletterFooter.isDeleting" (click)="deleteNewsletterFooter(newsletterFooter, newsletterFooter.id)">
                {{ newsletterFooter.isDeleting ? 'Deleting' : 'Delete' }}<span *ngIf="newsletterFooter.isDeleting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
